<template>
  <div>
    <router-link :to="`/laboratories/labs/${object.id}`">
      {{ object.title }}
    </router-link>
  </div>
</template>

<script setup>
defineProps({
  object: {
    type: Object
  },
})
</script>
